module.exports = __webpack_public_path__ + "static/media/Plagiarism_white.edf90184.png";